
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import ClusterTable from '../components/ClusterTable';

const Cluster = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/cluster/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Cluster Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Cluster
        </button>
      </div>

      <ClusterTable />
    </div>
  );
};

export default Cluster